import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "status", "submitButton" ]

  closeModal(event) {
    $('#choose_stories_modal').modal('hide');
  }

  publish(event) {
    event.preventDefault();
    event.currentTarget.innerHTML = "Saving...";
    event.currentTarget.setAttribute("style", "pointer-events: none; opacity: 0.5;");
    this.statusTarget.value = event.currentTarget.dataset.value;
    this.submitButtonTarget.click();
  }

  accessibleStatus(event){
    event.preventDefault();
    this.submitButtonTarget.click();
  }
}
